import React, { useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { Button, Checkbox, CssBaseline, FormControlLabel, Grid} from '@material-ui/core';
import PrintIcon from '@material-ui/icons/Print';
import html2canvas from "html2canvas";
import jsPDF from 'jspdf';
// import { useReactToPrint } from 'react-to-print';

import { DateRangePickerF } from './dateTimePicker/DateRangePickerF';
import { ReportPrintScreen } from './ReportPrintScreen';
import { ReportModelAlertsTable } from './modelReportAlerts/ReportModelAlertsTable';
import { useStyles } from './reportStyles';
import './css/reportPrint.css'
// import { htmlToCanvasImage } from '../../helpers/generalFunctions';




export const ReportScreen = () => {

    const classes = useStyles();
    const {startDate:validation,namePoint} = useSelector(state => state.print)
    const [check, setCheck] = useState(false);

    const componentRef = useRef();


    /**
     * To print screen with jsPDF
     * @param {event} e 
     */
    const div2PDF = async e => {

        let input = window.document.getElementById("PRINT");
        const canvas = await html2canvas(input)
        const imgData = canvas.toDataURL('img/png');
        const pdf = new jsPDF('p', 'mm', 'a4');

        // //Page 1
        // const title = await htmlToCanvasImage('titleReport')
        // pdf.addImage(title, 'PNG', -95, 15, 400, 20);
        // const reportDescriptionTable = await htmlToCanvasImage('ReportDescriptionTable')
        // pdf.addImage(reportDescriptionTable, 'PNG', 20, 35, 80, 30);
        // const reportAlarmTables = await htmlToCanvasImage('ReportAlarmTables')
        // pdf.addImage(reportAlarmTables, 'PNG', 100, 35, 80, 30);

        // pdf.setFontSize(9)
        // pdf.text('Página 1',190,295)

        // pdf.addPage()

        // pdf.addImage(imgData2, 'PNG', 0, 0, imgWidth, imgHeight );
        // pdf.setFontSize(9)
        // pdf.text('Página 2',190,295)

        const width = pdf.internal.pageSize.getWidth();
        const height = pdf.internal.pageSize.getHeight();
        
        pdf.addImage(imgData, 'PNG', 0, 0, width, height );
        pdf.setFontSize(6)
        pdf.text('Página 1',190,295)
        
        pdf.save(`Reporte_${namePoint}`);
    };



    // /**
    //  * Function that allow print the screen
    //  */
    // const handlePrint = useReactToPrint({
    //     content: () => componentRef.current,
    // });

    
    /**
     * Function that allows set the value of the check
     * @param {Event} event 
     */
    const handleChangeView = (event) =>{
        setCheck(event.target.checked)
    }

    return (
        <>
            <CssBaseline />

            <main className={classes.content}>
                <div className={classes.appBarSpacer} />

                    <Grid container  className={classes.container} >

                        <Grid item xs={12} md={12} lg={12} className={classes.buttonCenter}>
                            <DateRangePickerF/>
                        </Grid>

                    {!!validation &&
                        <Grid item xs={12} md={12} lg={12} className={classes.buttonCenter}>
                            <FormControlLabel
                                control={<Checkbox value="remember" color="primary" />}
                                label="Visualizar"
                                onChange={handleChangeView}
                            />
                            <Button
                                variant="contained"
                                color="primary"
                                size="large"
                                startIcon={<PrintIcon />}
                                onClick={div2PDF}
                                style={{ marginBottom: 10 }}
                                disabled={!check}
                            >
                                Guardar
                            </Button>
                        </Grid>


                    }

                    </Grid>

                    <Grid 
                        container 
                        spacing={3} 
                        className={classes.container} 
                        ref={componentRef} 
                        id="PRINT" 
                        style={ check ? {display:'flex'}:{}}
                    >
                            <ReportPrintScreen/>
                    </Grid>

                    <Grid
                        container 
                        spacing={3} 
                        className={classes.container} 
                    >
                        <ReportModelAlertsTable/>
                    </Grid>


                   
            </main>
        </>
    )
}

